export default "__VITE_ASSET__DcV7jhN0__"